(function () {
	'use strict';

	function init() {
		const menuItemSelector = '.js-offcanvas-menu-item';
		const submenuSelector = '.js-offcanvas-menu-submenu';
		const submenuBackSelector = '.js-offcanvas-menu-submenu-back';
		const submenuLinkSelector = '.js-offcanvas-menu-submenu-link';

		const offcanvas = document.querySelector('.js-site-offcanvas');
		const triggers = offcanvas.querySelectorAll('.js-offcanvas-menu-link');
		const backTriggers = offcanvas.querySelectorAll('.js-offcanvas-menu-submenu-back');
		const submenuLinks = offcanvas.querySelectorAll(submenuLinkSelector);

		const activeClass = 'is-active';

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();

				const submenu = trigger.closest(menuItemSelector).querySelector(submenuSelector);

				submenu.classList.add(activeClass);
				document.activeElement.blur();
			});
		});

		backTriggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				const submenu = e.currentTarget.closest(submenuSelector);
				submenu.classList.remove(activeClass);
			});
		});

		submenuLinks.forEach((submenuLink) => {
			submenuLink.addEventListener('click', () => {
				offcanvas.classList.remove(activeClass);
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
